module.exports = __webpack_public_path__ + "static/img/back_logo.7d0a940.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/back_logo.png
// module id = UDWf
// module chunks = 1